import React, { ReactElement, useEffect } from 'react';
import { Form } from 'formik';
import { booleanOptions } from '../../../../../data/enumerations';
import FormRadio from '../../../../components/Form/FormRadio';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import { WizardStep } from '../../../../../types';
import StepHeader from '../../../../components/Layout/StepHeader';

const StepHavePENB = ({ completeStep, setNextStepId }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    useEffect(() => {
        if (values.penB) {
            const nextStepId = values.penB === 'false' ? WizardStep.HouseFloorPlanShape : WizardStep.TypeOfPENB;
            setNextStepId && setNextStepId(nextStepId);
            completeStep && completeStep(true);
        }
    }, [values]);

    return (
        <Form>
            <div className="otz-main otz-main--small">
                <StepHeader
                    title="Máte po ruce průkaz budovy? (PENB)"
                    img={{ url: '/img/data/penb-header.png', alt: 'PENB průkaz' }}
                />
                <div className={'otz-main__grid'}>
                    {booleanOptions.map(({ value, title }, index) => {
                        return (
                            <FormRadio
                                name="penB"
                                value={value}
                                id={value}
                                label={title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={'wiz-form-radio--fullwidth wiz-form-radion--small m-b-0'}
                                checked={value === values.penB}
                                key={index}
                            />
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepHavePENB;
